import React, { useState } from "react";
import TypeApi from "../../api/TypeApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function AddDetails({ onAdded }) {

  const [type, setType] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!type.trim()) {
      setErrors({ type: "Type is required" });
      return;
    }

    try {
      const payload = { type };
      const res = await TypeApi.add(payload);

      if (res.code === 200) {
        showSuccess(res.message);
         document.getElementById("closeOffcanvasBtn").click();

        setType("");
        setErrors({});

        if (onAdded) onAdded();
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Add Type</h4>
          <button type="button" className="btn-close" data-bs-dismiss="modal" id="closeOffcanvasBtn" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body container">
            <div className="mb-3">
              <label className="form-label">Type</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter type"
                value={type}
                onChange={(e) => setType(e.target.value)}
              />
              {errors.type && (
                <span className="text text-danger">{errors.type}</span>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Add
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddDetails;